
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/financial",
      function () {
        return require("private-next-pages/ir/financial/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/financial"])
      });
    }
  